import React from 'react';
import { Modal, Button } from 'react-bootstrap';  
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeKatex from 'rehype-katex';
import styles from '../FileSelector.module.scss';
import { useMsal } from '@azure/msal-react';
import useAccessToken from "../../../../hooks/useAccessToken";
import { useState } from 'react';
import { marked } from 'marked';
import { useTasksContext } from '../../../../contexts/TasksContext';

interface SummaryModalProps {
  showSummaryModal: boolean;
  setShowSummaryModal: (show: boolean) => void;
  docSummary: { title: string; long: string; short: string };
  setDocSummary: (summary: { title: string; long: string; short: string }) => void;
  setSummaryView: (summaryView: {viewed: boolean, doc: string, summary: string}) => void;
}

const SummaryModal: React.FC<SummaryModalProps> = ({
  showSummaryModal,
  setShowSummaryModal,
  docSummary, 
  setDocSummary,
  setSummaryView
}) => {

  const { accounts } = useMsal();
  const accessToken = useAccessToken();
  const [isSent, setIsSent] = useState(false);

  const email = accounts[0]?.username;

  const { selectFilebyName } = useTasksContext();

  const handleAttachSummary = () => {
    setSummaryView({viewed: true, doc: docSummary.title, summary: docSummary.long});
    selectFilebyName(docSummary.title);
    setShowSummaryModal(false);
    setIsSent(false);
  }

  const sendEmail = async () => {

    const subject = "Georges - Summary of " + docSummary.title;
    const body = "<h3>Summary of " + docSummary.title + "</h3>" + "\n\n" + marked(docSummary.long);

    const emailData = {
        message: {
            subject: subject,
            body: {
                contentType: "HTML",
                content: body,
            },
            toRecipients: [
                {
                    emailAddress: {
                        address: email,
                    },
                },
            ],
        },
    };

    const response = await fetch("https://graph.microsoft.com/v1.0/me/sendMail", {
      method: "POST",
      headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
      },
      body: JSON.stringify(emailData),
    });

    if (response.ok) {
        console.log("Email sent successfully!");
        setIsSent(true);
    } else {
        console.error("Failed to send email", await response.text());
    }
  };


  return (
    <Modal 
      show={showSummaryModal} 
      onHide={() => {setShowSummaryModal(false); setDocSummary({title: "", long: "", short: ""}); setIsSent(false)}}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Summary</Modal.Title>
        <div style={{display: "flex", flex: 1, justifyContent: "flex-end", alignItems: "center", gap: 30}}>
          {isSent ? <div style={{color: "green", fontWeight: "bold"}}>Email sent</div> : <Button variant="secondary" onClick={sendEmail}>Send by email</Button>}  
          <Button variant="primary" onClick={handleAttachSummary}>View summary and deep-dive in document</Button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <h3>{docSummary.title}</h3>
        <ReactMarkdown
          className={styles.markdown}
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw, rehypeKatex]}
        >
          {docSummary.short}
        </ReactMarkdown>
        <h3>Summary</h3>
        <ReactMarkdown
          className={styles.markdown}
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw, rehypeKatex]}
        >
          {docSummary.long}
        </ReactMarkdown>
      </Modal.Body>
    </Modal>
  );
};

export default SummaryModal;